import { useGetSettlementsForCounties } from "modules/common";
import React, { useMemo } from "react";
import { Filter, Loading, ToggleSwitch } from "..";

interface Props {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: number[];
    countyFilter: number[];
}

export const SettlementFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
    countyFilter,
}) => {
    const { data: settlements, isFetching } = useGetSettlementsForCounties(
        countyFilter,
        countyFilter.length !== 0
    );

    const renderFilter = useMemo(() => {
        if (countyFilter.length === 0) return <p>Odaberite županiju</p>;
        else if (isFetching) return <Loading size="small" />;
        else if (settlements?.length)
            return settlements?.map(({ name, id }) => {
                return (
                    <div key={id}>
                        <ToggleSwitch
                            value={id?.toString()}
                            checked={value.includes(id!)}
                            onChange={onChange}
                            htmlFor={name}
                            text={
                                <div className="filter__item__text">{name.toLocaleUpperCase()}</div>
                            }
                        />
                    </div>
                );
            });

        return <p>Nema podataka</p>;
    }, [countyFilter.length, isFetching, settlements, value]);

    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="GRAD"
        >
            {renderFilter}
        </Filter>
    );
};
